import type { IChangeHistoryEntry } from '@modules/change-history/components/VChangeHistory/types';

export enum TableColumnsListType {
  ENABLED = 'enabled_list',
  DISABLED = 'disabled_list',
}

export interface ITableColumn {
  enabled: boolean;
  id: number | string;
  name: string;
  permanent: boolean;
  position: number | null;
}

export interface ITableColumnsResponse {
  list: ITableColumn[];
}

export interface IHistoryChangesOfTableColumnsResponse {
  list: IChangeHistoryEntry[];
}

export interface IColumnForSave {
  column_id: number;
  enabled: boolean;
  position: number | null;
}

export interface ISaveTableColumnsPayload {
  table_id: number;
  table_column_for_displays: IColumnForSave[];
}
